import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, Download, FlaskConical, Link2, Undo2 } from 'lucide-react'
import { money } from '../financial/formatting'
import StatusPill from './StatusPill'
import { fmtFull } from './model'

// The lead at a glance: status, the main reason, and the facts staff ask
// for first. Copy link shares this exact view; Download full JSON is the
// detail response as it arrived, nothing added.
export default function LeadHeader({ header, timezone, onCopyLink, onDownload }) {
  const reason = header.reason
  const payout = header.partner_payout_state === 'not_determined'
    ? 'Not determined'
    : header.partner_payout === null || header.partner_payout === undefined ? null : money(header.partner_payout)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Link to="/lead-inspector" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none', width: 'fit-content' }}>
        <ArrowLeft size={14} aria-hidden="true" /> Lead Inspector
      </Link>

      {header.test_mode && (
        <div role="note" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', borderRadius: 8, fontSize: 13, fontWeight: 600, color: 'var(--amber)', background: 'var(--amber-bg)' }}>
          <FlaskConical size={16} aria-hidden="true" />
          Test lead - sent in test mode, not real traffic.
        </div>
      )}

      <header className="li-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>Lead #{header.lead_id}</h1>
            <StatusPill status={header.status} size="lg" />
          </div>
          {reason && (
            <p style={{ margin: 0, fontSize: 14, color: 'var(--text-secondary)' }}>
              <strong style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{reason.label}</strong>
              {reason.detail && <> · {reason.detail}</>}
            </p>
          )}
        </div>
        <div className="li-header-actions" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexShrink: 0 }}>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onCopyLink}>
            <Link2 size={14} aria-hidden="true" /> Copy link
          </button>
          <button type="button" className="btn btn-primary btn-sm" onClick={onDownload}>
            <Download size={14} aria-hidden="true" /> Download full JSON
          </button>
        </div>
      </header>

      <div className="li-facts">
        <Fact label="Received" value={`${fmtFull(header.received_at, timezone)} ET`} />
        <Fact label="Origin · Sub ID" value={<>{header.origin?.name}{header.sub_id && <span style={{ color: 'var(--text-muted)' }}> · <span className="li-mono">{header.sub_id}</span></span>}</>} />
        <Fact label="Revenue" value={header.revenue === null || header.revenue === undefined ? null : money(header.revenue)} />
        <Fact label="Partner payout" value={payout} />
        <Fact label="Click ID" value={header.click_id && <span className="li-mono">{header.click_id}</span>} />
        <Fact label="Vertical" value={header.vertical} />
      </div>

      {header.attribution_reversed_at && (
        <p style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '8px 12px', borderRadius: 8, color: 'var(--purple)', background: 'var(--purple-bg)' }}>
          <Undo2 size={14} aria-hidden="true" />
          Partner attribution reversed on {fmtFull(header.attribution_reversed_at, timezone)} ET.
        </p>
      )}
    </div>
  )
}

function Fact({ label, value }) {
  return (
    <div className="li-fact">
      <span className="li-fact-label">{label}</span>
      <span className="li-fact-value">{value || <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}>—</span>}</span>
    </div>
  )
}
